// @flow
import type { FSA } from 'types/redux';
import type {
  CohortDriver,
  CohortPassenger,
  Driver,
  Passenger,
  Merchants,
} from 'types/entities';

import _ from 'lodash';

import {
  LIBRARY_PASSENGER_ADD,
  LIBRARY_PASSENGER_DELETE,
  LIBRARY_DRIVER_ADD,
  LIBRARY_DRIVER_DELETE,
  LIBRARY_MERCHANT_ADD,
  LIBRARY_MERCHANT_DELETE,
} from 'actions/library';

export type PassengerLibraryState = {
  [id: string]: Passenger & CohortPassenger,
};

export type DriverLibraryState = {
  [id: string]: Driver & CohortDriver,
};

export type MerchantLibraryState = Merchants;

export type LibraryState = {
  passengers: PassengerLibraryState,
  drivers: DriverLibraryState,
  merchants: MerchantLibraryState,
};

export const defaultPassengerLibraryState: PassengerLibraryState = {};
export const defaultDriverLibraryState: DriverLibraryState = {};
export const defaultMerchantLibraryState: MerchantLibraryState = {};

export const defaultLibraryState: LibraryState = {
  passengers: defaultPassengerLibraryState,
  drivers: defaultDriverLibraryState,
  merchants: defaultMerchantLibraryState,
};

export function passengers(state: PassengerLibraryState = defaultPassengerLibraryState,
  action: FSA) {
  switch (action.type) {
    case LIBRARY_PASSENGER_ADD:
      return {
        ...state,
        [action.payload.cohortPassengerID]: action.payload,
      };
    case LIBRARY_PASSENGER_DELETE:
      return _.omit(state, action.payload.cohortPassengerID);
    default:
      return state;
  }
}

export function drivers(state: DriverLibraryState = defaultDriverLibraryState, action: FSA) {
  switch (action.type) {
    case LIBRARY_DRIVER_ADD:
      return {
        ...state,
        [action.payload.cohortDriverID]: action.payload,
      };
    case LIBRARY_DRIVER_DELETE:
      return _.omit(state, action.payload.cohortDriverID);
    default:
      return state;
  }
}

export function merchants(state: MerchantLibraryState = defaultMerchantLibraryState, action: FSA) {
  switch (action.type) {
    case LIBRARY_MERCHANT_ADD:
      return {
        ...state,
        [action.payload.cohortMerchantID]: action.payload,
      };
    case LIBRARY_MERCHANT_DELETE:
      return _.omit(state, action.payload.cohortMerchantID);
    default:
      return state;
  }
}

function library(state: LibraryState = defaultLibraryState, action: FSA) {
  switch (action.type) {
    case LIBRARY_PASSENGER_ADD:
    case LIBRARY_PASSENGER_DELETE:
      return {
        ...state,
        passengers: passengers(state.passengers, action),
      };
    case LIBRARY_DRIVER_ADD:
    case LIBRARY_DRIVER_DELETE:
      return {
        ...state,
        drivers: drivers(state.drivers, action),
      };
    case LIBRARY_MERCHANT_ADD:
    case LIBRARY_MERCHANT_DELETE:
      return {
        ...state,
        merchants: merchants(state.merchants, action),
      };
    default:
      return state;
  }
}

export default library;



/** WEBPACK FOOTER **
 ** ./src/js/reducers/library.js
 **/